var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.988,
    viewBox: "0 0 24 21.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription",
    transform: "translate(0 -5.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114568",
    "data-name": "Group 114568",
    transform: "translate(2.126 13.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114561",
    "data-name": "Group 114561",
    transform: "translate(0 4.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114560",
    "data-name": "Group 114560",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365939",
    "data-name": "Path 365939",
    d: "M39.921,305.014H37.4a.286.286,0,0,1-.286-.286v-2.516a.286.286,0,0,1,.286-.286h2.516a.286.286,0,0,1,.286.286v2.516A.286.286,0,0,1,39.921,305.014Z",
    transform: "translate(-37.118 -301.925)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_365940",
    "data-name": "Path 365940",
    d: "M121.658,301.924h-2.516a.286.286,0,0,0-.286.286v2.516a.286.286,0,0,0,.286.286h2.516a.286.286,0,0,0,.286-.286V302.21A.286.286,0,0,0,121.658,301.924Z",
    transform: "translate(-114.173 -301.924)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_114564",
    "data-name": "Group 114564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114562",
    "data-name": "Group 114562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365941",
    "data-name": "Path 365941",
    d: "M39.921,225.265H37.4a.286.286,0,0,1-.286-.286v-2.516a.286.286,0,0,1,.286-.286h2.516a.286.286,0,0,1,.286.286v2.516A.286.286,0,0,1,39.921,225.265Z",
    transform: "translate(-37.118 -222.176)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_114563",
    "data-name": "Group 114563",
    transform: "translate(4.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365942",
    "data-name": "Path 365942",
    d: "M121.658,225.265h-2.516a.286.286,0,0,1-.286-.286v-2.516a.286.286,0,0,1,.286-.286h2.516a.286.286,0,0,1,.286.286v2.516A.286.286,0,0,1,121.658,225.265Z",
    transform: "translate(-118.855 -222.176)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114567",
    "data-name": "Group 114567",
    transform: "translate(0 9.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114565",
    "data-name": "Group 114565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365943",
    "data-name": "Path 365943",
    d: "M39.921,384.762H37.4a.286.286,0,0,1-.286-.286v-2.516a.286.286,0,0,1,.286-.286h2.516a.286.286,0,0,1,.286.286v2.516A.286.286,0,0,1,39.921,384.762Z",
    transform: "translate(-37.118 -381.673)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_114566",
    "data-name": "Group 114566",
    transform: "translate(4.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365944",
    "data-name": "Path 365944",
    d: "M121.658,384.762h-2.516a.286.286,0,0,1-.286-.286v-2.516a.286.286,0,0,1,.286-.286h2.516a.286.286,0,0,1,.286.286v2.516A.286.286,0,0,1,121.658,384.762Z",
    transform: "translate(-118.855 -381.673)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114570",
    "data-name": "Group 114570",
    transform: "translate(10.933 13.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365945",
    "data-name": "Path 365945",
    d: "M240.153,276.36a.51.51,0,0,0-.708.135l-.139.2a6.1,6.1,0,1,0-5.918,7.644,5.933,5.933,0,0,0,3.691-1.278.51.51,0,1,0-.629-.8,4.923,4.923,0,0,1-3.062,1.061,5.208,5.208,0,1,1,4.885-6.56l-.088-.083a.51.51,0,1,0-.7.739l1.123,1.068a.511.511,0,0,0,.773-.083l.908-1.337A.51.51,0,0,0,240.153,276.36Z",
    transform: "translate(-227.309 -271.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_114569",
    "data-name": "Group 114569",
    transform: "translate(4.4 2.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365946",
    "data-name": "Path 365946",
    d: "M269.96,297.445c-.694-.287-.894-.462-.894-.779,0-.254.185-.551.707-.551a2.191,2.191,0,0,1,1.049.321l.283-.747a2.319,2.319,0,0,0-1.046-.337v-.766h-.73v.812a1.385,1.385,0,0,0-1.181,1.361c0,.818.658,1.189,1.367,1.467.573.233.807.47.807.818,0,.386-.325.645-.808.645a2.163,2.163,0,0,1-1.189-.4l-.272.759a2.121,2.121,0,0,0,1.221.416v.8h.737v-.835a1.472,1.472,0,0,0,1.236-1.432C271.249,298.276,270.863,297.813,269.96,297.445Z",
    transform: "translate(-268.054 -294.587)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114603",
    "data-name": "Group 114603",
    transform: "translate(0 2.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365956",
    "data-name": "Path 365956",
    d: "M21.506,88.747H17.178v-.79a1.257,1.257,0,0,0-2.514,0v.79H12.61v-.79a1.257,1.257,0,0,0-2.514,0v.79H8.042v-.79a1.257,1.257,0,0,0-2.514,0v.79H1.2a1.2,1.2,0,0,0-1.2,1.2v17.541a1.2,1.2,0,0,0,1.2,1.2H8.724c.158,0,.4-.1.4-.581s-.166-.556-.325-.556H1.662a.628.628,0,0,1-.627-.627L.958,93.49H22.419a.286.286,0,0,0,.286-.286V89.947A1.2,1.2,0,0,0,21.506,88.747Zm-6.269.562a.684.684,0,0,1,1.369,0v2.153a.685.685,0,0,1-.684.684h0a.685.685,0,0,1-.684-.684Zm-4.568,0a.684.684,0,0,1,1.369,0v2.153a.684.684,0,0,1-1.369,0Zm-4.568,0a.684.684,0,0,1,1.369,0v2.153a.684.684,0,0,1-1.369,0Z",
    transform: "translate(0 -83.743)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.fde2af2983dd2ef888f0bee04c221fab.svg";
export { ForwardRef as ReactComponent };